import {openPanel} from '../sidePanel-action'

import './dropUp.styl'
export function dropUp(containerId, data, className=false) {
    return openPanel(containerId, data, 'sidePanel-dropUp' + (className ? ' ' + className : ''))
}

/**
 * @deprecated
 */
export const sidePanelDropUp = dropUp
